import { render, staticRenderFns } from "./ClaimLightList.vue?vue&type=template&id=c3cf2d8e&"
import script from "./ClaimLightList.vue?vue&type=script&lang=js&"
export * from "./ClaimLightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports